/* ==========================================================================
   Exit survey — "what's holding you back?"
   --------------------------------------------------------------------------
   Rendered by sections/mas-exit-survey.liquid, which leaves its settings in
   #mas-exit-survey-config. See docs/exit-survey.md.

   Two places it asks, once per visit and at most once a fortnight:

     workshop   a pop-up workshop page. Asks when the visitor looks like
                leaving without booking: the mouse heading for the tab bar
                (computers); reaching the end of the page or going still
                (phones, where there is no exit to detect); coming back to the
                tab after leaving it (both). The page's FAQ can also open it
                with a link to #tell-us-what-works.
     site       any other page, a few minutes after such a workshop page,
                when they did not book: "You were looking at our [city]
                workshop. What stopped you from booking?"

   It never shows while the booking dialog is open (html.masbk-lock), the
   chat is open, or any other dialog is, once the visitor has clicked
   checkout or added a booking to the cart, while they are typing, or on a
   page view where a Klaviyo form or the welcome offer (mas-welcome-offer.js)
   has already popped up. While it is up, the chat button is hidden.

   A third ask, for someone who put a booking in the cart, went to checkout
   and came back to the site without paying: "What stopped you from
   finishing your booking?", with its own answers and a way back to checkout.

   The answers are plain tiles or, for half the visitors (setting "Answers"),
   a small game, Mosaic match: each answer carries a glass tile, and tapping
   it plays the tile into a mosaic board above the question. The answer is
   recorded on the tap, before the game plays; the follow-up step comes after.

   Answers go to dataLayer and Microsoft Clarity as exit_survey_* events
   (mas_exit_survey_* in Clarity) plus the Clarity tags exit_reason,
   exit_days and exit_trigger, and the session is upgraded so the recording
   is kept. Optionally also to an endpoint (sendBeacon, for Mosaic OS), the
   only place free text ("Something else") ever goes, and, for an email
   address the visitor chooses to leave, to a Klaviyo list.
   ========================================================================== */
(function () {
  'use strict';

  var node = document.getElementById('mas-exit-survey-config');
  if (!node || window.MASExitSurvey) return;
  var cfg;
  try { cfg = JSON.parse(node.textContent); } catch (e) { return; }

  var VISIT = 'mas-exit-survey:visit';     // sessionStorage: the last pop-up workshop page
  var SHOWN = 'mas-exit-survey:shown';     // sessionStorage: already asked this visit
  var SHOWN_CHECKOUT = 'mas-exit-survey:shown-checkout'; // sessionStorage: asked about the unfinished booking
  var PREVIEW = 'mas-exit-survey:preview'; // sessionStorage: arrived on a ?exit_survey=preview link
  var CAP = 'mas-exit-survey';             // localStorage: { snoozeUntil, answeredUntil }
  var STYLE = 'mas-exit-survey:style';     // localStorage: this visitor's half of the test, game or plain
  var STYLE_PREVIEW = 'mas-exit-survey:style-preview'; // sessionStorage: ?exit_style=game|plain
  var DAY_MS = 864e5;
  var AWAY_MS = 5000;                      // "came back to the tab" means away at least this long
  var COPIED = 'Link copied — paste it into your chat.';

  var T = cfg.timing || {};
  var text = cfg.text || {};
  var isWorkshop = cfg.mode === 'workshop';

  /* ---------- storage and analytics helpers --------------------------- */

  function read(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function write(store, k, v) { try { window[store].setItem(k, v); } catch (e) { /* private mode */ } }
  function readJSON(store, k) { try { return JSON.parse(read(store, k) || 'null'); } catch (e) { return null; } }

  if (/[?&]exit_survey=(preview|open)\b/.test(location.search)) write('sessionStorage', PREVIEW, '1');
  // For testing: ?exit_survey=open is preview that also opens the sheet
  // straight away; add &exit_ask=checkout for the unfinished-booking question
  // without needing a real booking in the cart.
  var openNow = /[?&]exit_survey=open\b/.test(location.search);
  var forceCheckout = /[?&]exit_ask=checkout\b/.test(location.search);
  var forceStyle = /[?&]exit_style=(game|plain)\b/.exec(location.search);
  if (forceStyle) write('sessionStorage', STYLE_PREVIEW, forceStyle[1]);
  // Preview: the editor's checkbox, or a ?exit_survey=preview link earlier in
  // this visit. It skips the waiting and the limits, so it can be checked on
  // the live site while the survey is in Test.
  var preview = !!cfg.editor || read('sessionStorage', PREVIEW) === '1';
  var active = cfg.state === 'live' || preview;

  function onPageMs() { return window.performance && performance.now ? performance.now() : 0; }
  function seconds() { return Math.round(onPageMs() / 1000); }   // for reporting
  function past(min) { return onPageMs() >= min * 1000; }        // for "not before"
  function clarity() {
    try {
      window.clarity = window.clarity || function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
      window.clarity.apply(window, arguments);
    } catch (e) { /* analytics must never break the page */ }
  }
  // What the booking widget has reported on this page (it pushes to dataLayer).
  function seen(name) {
    var dl = window.dataLayer || [];
    for (var i = dl.length - 1; i >= 0; i--) if (dl[i] && dl[i].event === name) return dl[i];
    return null;
  }
  function pageState() {
    var cv = seen('booking_seen') || seen('calendar_visible');
    return {
      sawDates: !!seen('booking_seen'),
      started: !!(seen('date_selected') || seen('session_selected')),
      booked: !!(seen('checkout_clicked') || seen('booking_added_to_cart')),
      bucket: (cv && cv.next_date_bucket) || null
    };
  }

  var ctx = {};   // the workshop being asked about, and the answers so far
  function payload(extra) {
    var p = {
      survey_mode: cfg.mode,
      survey_style: ctx.style || null,
      question: ctx.question || 'booking',
      trigger: ctx.trigger,
      city: ctx.city || null,
      product: ctx.product || null,
      next_date_bucket: ctx.bucket || null,
      saw_dates: !!ctx.sawDates,
      started_booking: !!ctx.started,
      seconds_on_page: seconds()
    };
    for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
    return p;
  }
  function track(evt, extra) {
    var name = 'exit_survey_' + evt;
    try {
      window.dataLayer = window.dataLayer || [];
      var p = payload(extra);
      p.event = name;
      window.dataLayer.push(p);
    } catch (e) { /* analytics must never break the page */ }
    clarity('event', 'mas_' + name);
  }
  // Anonymous answers to the optional endpoint. text/plain keeps sendBeacon
  // clear of a CORS preflight; the receiver parses the body as JSON.
  function send(type, extra) {
    if (!cfg.endpoint || !navigator.sendBeacon) return;
    try {
      var p = payload(extra);
      p.type = type;
      p.sid = ctx.sid;   // one id per ask, so an answer, its days and its text can be joined
      p.page = location.pathname;
      p.at = new Date().toISOString();
      navigator.sendBeacon(cfg.endpoint, new Blob([JSON.stringify(p)], { type: 'text/plain' }));
    } catch (e) { /* best effort */ }
  }

  function fill(str) {
    var city = ctx.city || '';
    str = String(str || '');
    return city ? str.replace(/\[city\]/g, city) : str.replace(/\[city\]\s?/g, '');
  }
  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }
  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  /* ---------- may we ask now? ----------------------------------------- */

  var klaviyoOpen = false, klaviyoShown = false;
  // Klaviyo's onsite script announces its forms on window. An embedded form
  // ("embedOpen") is part of the page, not a pop-up, so it does not count.
  window.addEventListener('klaviyoForms', function (e) {
    var t = e && e.detail && e.detail.type;
    if (t === 'open') { klaviyoOpen = true; klaviyoShown = true; }
    else if (t === 'close') klaviyoOpen = false;
  });
  // Zapier's chat (layout/theme.liquid) reports open and closed with window
  // messages; assets/wsp-sticky-bar.js reads the same two on workshop pages.
  var chatOpen = false;
  window.addEventListener('message', function (e) {
    if (e.data === 'zChatbotOpened') chatOpen = true;
    else if (e.data === 'zChatbotClosed') chatOpen = false;
  });

  function capped() {
    if (preview) return false;
    if (read('sessionStorage', SHOWN)) return true;
    var c = readJSON('localStorage', CAP) || {};
    var now = Date.now();
    return (c.snoozeUntil && now < c.snoozeUntil) || (c.answeredUntil && now < c.answeredUntil);
  }
  function busy() {
    var html = document.documentElement;
    if (html.classList.contains('masbk-lock')) return true;      // the booking dialog
    if (html.classList.contains('mwo-open')) return true;        // the welcome offer (mas-welcome-offer.js)
    if (html.classList.contains('mlr-lock')) return true;        // the lamp design reel (mas-lamp-reel.js)
    if (chatOpen || html.classList.contains('wsp-chat-open')) return true;  // a chat in progress
    if (document.querySelector('.pswp--open')) return true;      // photo zoom
    var modals = document.querySelectorAll('[aria-modal="true"]');
    for (var i = 0; i < modals.length; i++) if (modals[i].offsetParent !== null) return true;
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
    return klaviyoOpen;
  }
  // The welcome offer opened in this page view: one pop-up is enough.
  function offerHere() { return !!(window.MASWelcomeOffer && window.MASWelcomeOffer.shownHere()); }
  // Automatic asks only: one per page view (even in preview), none after a
  // Klaviyo pop-up or the welcome offer on the same page view.
  function mayAsk() {
    if (!active || sheet || askedHere || klaviyoShown || offerHere() || document.hidden || capped()) return false;
    if (isWorkshop && (pageState().booked || bookedBefore || bookingPending)) return false;
    return !busy();
  }

  /* ---------- the sheet ------------------------------------------------ */

  var sheet = null, body = null, liveMsg = null, fx = null, askedHere = false;

  function ensureCss() {
    if (!cfg.css || document.querySelector('link[data-mxs-css]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = cfg.css;
    l.setAttribute('data-mxs-css', '');
    document.head.appendChild(l);
  }

  function capFor(days, key) {
    if (preview) return;
    var c = readJSON('localStorage', CAP) || {};
    c[key] = Date.now() + days * DAY_MS;
    write('localStorage', CAP, JSON.stringify(c));
  }

  function shuffledOptions() {
    var opts = (cfg.options || []).filter(function (o) { return o.label; });
    var head = opts.filter(function (o) { return o.key !== 'browsing' && o.key !== 'other'; });
    var tail = opts.filter(function (o) { return o.key === 'browsing' || o.key === 'other'; });
    for (var i = head.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1)), t = head[i];
      head[i] = head[j]; head[j] = t;
    }
    return head.concat(tail);
  }

  // Plain tiles or the game. Half and half: each visitor is given one at random
  // and keeps it (localStorage), so the two halves can be compared by
  // survey_style. ?exit_style=game|plain overrides it for the visit.
  function surveyStyle() {
    var forced = read('sessionStorage', STYLE_PREVIEW);
    if (forced === 'game' || forced === 'plain') return forced;
    if (cfg.style === 'game' || cfg.style === 'plain') return cfg.style;
    var s = read('localStorage', STYLE);
    if (s !== 'game' && s !== 'plain') {
      s = Math.random() < 0.5 ? 'game' : 'plain';
      write('localStorage', STYLE, s);
    }
    return s;
  }

  function open(opts) {
    if (sheet) return;
    opts = opts || {};
    ensureCss();
    ctx.trigger = opts.trigger;
    ctx.question = opts.question === 'checkout' ? 'checkout' : 'booking';
    // A fresh ask: nothing carried over from an earlier one on this page.
    ctx.reason = null; ctx.days = null; ctx.answered = false;
    ctx.sid = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
    if (ctx.question === 'checkout') {
      ctx.style = 'plain';   // no game here: they were about to pay
      write('sessionStorage', SHOWN_CHECKOUT, '1');
      capFor(CHECKOUT_SNOOZE_DAYS, 'checkoutUntil');
    } else {
      ctx.style = surveyStyle();
      write('sessionStorage', SHOWN, '1');
      capFor(T.snoozeDays || 14, 'snoozeUntil');
    }

    sheet = el('div', 'mxs');
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'false');
    sheet.setAttribute('aria-labelledby', 'mxs-title');
    sheet.appendChild(el('span', 'mxs__grip'));
    var x = el('button', 'mxs__x');
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    x.addEventListener('click', function () { close('closed'); });
    sheet.appendChild(x);
    body = el('div', 'mxs__body');
    sheet.appendChild(body);
    liveMsg = el('p', 'mxs__sr');
    liveMsg.setAttribute('aria-live', 'polite');
    sheet.appendChild(liveMsg);
    fx = el('div', 'mxs__fx');   // the game's flying tiles and shards, clipped to the sheet
    fx.setAttribute('aria-hidden', 'true');
    sheet.appendChild(fx);
    document.body.appendChild(sheet);
    // While the sheet is up (mas-exit-survey.css): the chat button and the
    // workshop page's sticky book bar step aside, as both sit on top of it.
    document.documentElement.classList.add('mxs-open');
    document.addEventListener('keydown', onKey);

    if (opts.start === 'days' && (cfg.days || []).length) { ctx.reason = 'dates'; stepDays(); }
    else if (ctx.question === 'checkout') stepCheckout();
    else stepReason();
    track('shown');
    send('shown', {});   // so Mosaic OS can work out how many of those asked answer
    clarity('set', 'exit_trigger', ctx.trigger);
    clarity('set', 'exit_style', ctx.style);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { if (sheet) sheet.classList.add('is-in'); });
    });
    // Asked for (the FAQ link): take focus there. Shown on its own: don't
    // pull focus away from whatever the visitor was doing.
    if (opts.focus) setTimeout(function () { var b = sheet && sheet.querySelector('button.mxs__opt'); if (b) b.focus(); }, 60);
  }

  function close(why) {
    if (!sheet) return;
    track('closed', { step: ctx.step, reason: ctx.reason || null, how: why });
    var s = sheet;
    sheet = null;
    document.removeEventListener('keydown', onKey);
    document.documentElement.classList.remove('mxs-open');
    s.classList.remove('is-in');
    setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 260);
  }
  function onKey(e) { if (e.key === 'Escape' && sheet) close('escape'); }

  function head(eyebrow, str) {
    if (eyebrow) body.appendChild(el('p', 'mxs__eyebrow', fill(eyebrow)));
    var h = el('p', 'mxs__title', fill(str));
    h.id = 'mxs-title';
    body.appendChild(h);
  }
  function clear(step) {
    ctx.step = step;
    while (body.firstChild) body.removeChild(body.firstChild);
  }
  // One solid button per step (the brand's rule); everything else is a link.
  function action(tag, label, primary) {
    var n = el(tag, primary ? 'mxs__btn' : 'mxs__link');
    if (tag === 'button') n.type = 'button';
    n.appendChild(el('span', 'mxs__label', label));
    var arrow = el('span', 'mxs__arrow', '→');
    arrow.setAttribute('aria-hidden', 'true');
    n.appendChild(arrow);
    return n;
  }

  function stepReason() {
    clear('reason');
    var game = ctx.style === 'game';
    var stage = game ? el('div', 'mxs__stage') : null;
    if (stage) body.appendChild(stage);
    head(text.eyebrow, cfg.mode === 'site' ? text.headingNext : text.heading);
    var hint = game ? el('p', 'mxs__hint', 'Tap your answer to play its tile.') : null;
    if (hint) body.appendChild(hint);
    var list = el('div', game ? 'mxs__grid mxs__grid--game' : 'mxs__grid');
    var opts = shuffledOptions(), colours = shuffle(GLASS_KEYS), pieces = [], board = null, answered = false;
    opts.forEach(function (o, i) {
      var b = el('button', 'mxs__opt', game ? null : o.label);
      b.type = 'button';
      var k = colours[i % colours.length], piece = null;
      if (game) {
        // A glass tile on each answer. Colours are dealt at random per visitor,
        // so a favourite colour can't favour one answer.
        b.className = 'mxs__opt mxs__opt--game';
        piece = el('span', 'mxs__piece');
        piece.style.setProperty('--mxs-c', GLASS[k]);
        piece.setAttribute('aria-hidden', 'true');
        b.appendChild(piece);
        b.appendChild(el('span', 'mxs__optlabel', o.label));
        pieces.push(piece);
        // Pressing (or hovering) shows the move before it's made.
        var aimOn = function () { if (!answered && board) { board.preview(k); b.classList.add('is-aiming'); } };
        var aimOff = function () { if (!answered && board) { board.clear(); b.classList.remove('is-aiming'); } };
        b.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') aimOn(); });
        b.addEventListener('pointerdown', aimOn);
        b.addEventListener('pointerleave', aimOff);
        b.addEventListener('pointercancel', aimOff);
        b.addEventListener('focus', aimOn);
        b.addEventListener('blur', aimOff);
      }
      b.addEventListener('click', function () {
        if (answered) return;
        answered = true;
        if (!board || still) { answer(o.key); return; }
        b.classList.remove('is-aiming');
        b.classList.add('is-chosen');
        list.classList.add('is-answered');
        answer(o.key, function (next) {
          board.play(k, piece, next);
          piece.classList.add('is-spent');
        });
      });
      list.appendChild(b);
    });
    body.appendChild(list);
    if (!game) return;

    board = mosaicBoard(stage, fx);
    var hop = function (p) { if (!answered) retrigger(p, 'is-hop'); };
    var hopAll = function () { pieces.forEach(function (p, i) { later(stage, i * 70, function () { hop(p); }); }); };
    // Poking the board never answers; it points at the answers instead.
    stage.addEventListener('click', function () {
      if (answered) return;
      board.nudge();
      hopAll();
      retrigger(hint, 'is-poke');
    });
    if (still) return;
    // As it opens the answer tiles hop in turn, linking them to the board.
    // Then, every couple of seconds, one colour glints and its answer hops,
    // each answer in turn in a random order, so none is favoured.
    later(stage, 1450, hopAll);
    var order = shuffle(opts.map(function (o, i) { return i; })), n = 0;
    later(stage, 3200, function idle() {
      if (answered) return;
      if (!list.querySelector('.is-aiming')) {
        var i = order[n++ % order.length];
        board.glint(colours[i]);
        hop(pieces[i]);
      }
      later(stage, 2300, idle);
    });
  }

  // `play`, from the game: called with the next step once the answer is
  // recorded, and runs it when the game has played out.
  function answer(key, play) {
    ctx.reason = key;
    if (ctx.question !== 'checkout') capFor(T.answeredDays || 60, 'answeredUntil');
    track('answered', { reason: key });
    clarity('set', 'exit_reason', key);
    clarity('upgrade', 'exit_survey_answered');
    send('answer', { reason: key });
    var mine = sheet;
    var next = function () {
      if (!sheet || sheet !== mine) return;
      if (ctx.question !== 'checkout' && key === 'dates' && (cfg.days || []).length) stepDays();
      else stepDone();
    };
    if (play) play(next); else next();
  }

  // Someone who put a booking in the cart, went to checkout and came back
  // without paying. Its own answers; the first five shuffled.
  var CHECKOUT_SNOOZE_DAYS = 7;
  var CHECKOUT_OPTIONS = [
    { key: 'later', label: "I'll finish it later" },
    { key: 'total', label: 'The total at checkout' },
    { key: 'problem', label: 'Something went wrong at checkout' },
    { key: 'others', label: 'I need to check with someone' },
    { key: 'change', label: 'I want a different date or time' },
    { key: 'other', label: 'Something else' }
  ];
  function stepCheckout() {
    clear('reason');
    head(text.eyebrow, 'What stopped you from finishing your [city] booking?');
    body.appendChild(el('p', 'mxs__note', "It's still in your cart."));
    var list = el('div', 'mxs__grid'), answered = false;
    shuffle(CHECKOUT_OPTIONS.slice(0, 5)).concat(CHECKOUT_OPTIONS.slice(5)).forEach(function (o) {
      var b = el('button', 'mxs__opt', o.label);
      b.type = 'button';
      b.addEventListener('click', function () { if (!answered) { answered = true; answer(o.key); } });
      list.appendChild(b);
    });
    body.appendChild(list);
  }

  function stepDays() {
    clear('days');
    head(null, text.daysQ);
    var picked = {};
    var grid = el('div', 'mxs__grid');
    grid.setAttribute('role', 'group');
    var sendBtn = action('button', text.daysSend || 'Send', true);
    sendBtn.disabled = true;
    (cfg.days || []).forEach(function (label) {
      var c = el('button', 'mxs__opt mxs__opt--pick', label);
      c.type = 'button';
      c.setAttribute('aria-pressed', 'false');
      c.addEventListener('click', function () {
        var on = c.getAttribute('aria-pressed') !== 'true';
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) picked[slug(label)] = 1; else delete picked[slug(label)];
        sendBtn.disabled = !Object.keys(picked).length;
      });
      grid.appendChild(c);
    });
    body.appendChild(grid);
    var row = el('div', 'mxs__actions');
    row.appendChild(sendBtn);
    var skip = el('button', 'mxs__skip', 'Skip');
    skip.type = 'button';
    skip.addEventListener('click', function () { stepDone(); });
    row.appendChild(skip);
    body.appendChild(row);
    sendBtn.addEventListener('click', function () {
      // In the order shown, not the order tapped, so the same choice reads the same.
      ctx.days = (cfg.days || []).map(slug).filter(function (k) { return picked[k]; }).join(',');
      // The FAQ link opens here directly, so "dates" is first recorded now.
      if (ctx.trigger === 'faq_link' && !ctx.answered) {
        capFor(T.answeredDays || 60, 'answeredUntil');
        track('answered', { reason: 'dates' });
        clarity('set', 'exit_reason', 'dates');
        clarity('upgrade', 'exit_survey_answered');
        send('answer', { reason: 'dates' });
      }
      ctx.answered = true;
      track('days', { reason: 'dates', days: ctx.days });
      clarity('set', 'exit_days', ctx.days);
      send('days', { reason: 'dates', days: ctx.days });
      stepDone();
    });
  }

  function stepDone() {
    clear('done');
    var r = ctx.reason, checkout = ctx.question === 'checkout';
    head(null, text.thanks);
    if (!checkout && r === 'dates' && text.thanksDates) body.appendChild(el('p', 'mxs__note', fill(text.thanksDates)));
    if (checkout && r === 'later') body.appendChild(el('p', 'mxs__note', "It's in your cart whenever you're ready."));

    var email = !checkout && (r === 'dates' || r === 'browsing') && cfg.klaviyo && cfg.klaviyo.companyId && cfg.klaviyo.listId;
    // Free text only when there is somewhere safe to keep it (the endpoint).
    var words = !!cfg.endpoint && (r === 'other' || r === 'problem');
    var primaryUsed = false;
    var actions = el('div', 'mxs__actions');
    var add = function (n) { actions.appendChild(n); };

    if (email) { body.appendChild(emailForm()); primaryUsed = true; }
    if (words) { body.appendChild(textForm()); primaryUsed = true; }
    if (r === 'others') { add(shareButton()); primaryUsed = true; }
    if (!checkout && r === 'question') {
      var faq = isWorkshop ? document.querySelector('.wfaq-sec') : null;
      if (faq || ctx.url) {
        var fb = action(faq ? 'button' : 'a', text.faq, true);
        if (!faq) fb.href = ctx.url + '#faq';
        fb.addEventListener('click', function () { track('faq_clicked'); if (faq) { close('faq'); goTo(faq); } });
        add(fb);
        primaryUsed = true;
      }
    }
    if ((!checkout && r === 'question') || (checkout && r === 'problem')) {
      if (text.contactUrl) {
        var ca = action('a', text.contact, false);
        ca.href = text.contactUrl;
        ca.addEventListener('click', function () { track('contact_clicked'); });
        add(ca);
      }
    }
    // Back to checkout, except for someone who wants another date.
    if (checkout && r !== 'change') {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var fin = action('a', 'Finish my booking', !primaryUsed);
      fin.href = root + 'checkout';
      fin.addEventListener('click', function () { track('checkout_resumed'); });
      add(fin);
      primaryUsed = true;
    }
    if (!checkout || r === 'change') {
      if (isWorkshop) {
        var target = document.querySelector('[data-popup-booking], [data-mas-booking]');
        if (target) {
          var db = action('button', text.seeDates, !primaryUsed);
          db.addEventListener('click', function () { track('dates_clicked'); close('dates'); goTo(target); });
          add(db);
        }
      } else if (ctx.url) {
        var back = action('a', fill(text.backToDates), !primaryUsed);
        back.href = ctx.url;
        back.addEventListener('click', function () { track('dates_clicked'); });
        add(back);
      }
    }
    if (actions.firstChild) body.appendChild(actions);
    liveMsg.textContent = fill(text.thanks);
  }

  // Free text ("Something else", "Something went wrong at checkout"). It goes
  // to the answers endpoint (Mosaic OS) and nowhere else: never to Analytics
  // or Clarity, as people type names and phone numbers.
  function textForm() {
    var f = el('form', 'mxs__email mxs__words');
    f.noValidate = true;
    var q = el('label', 'mxs__q', ctx.reason === 'problem' ? 'What happened? (optional)' : 'Tell us more (optional)');
    q.htmlFor = 'mxs-words';
    f.appendChild(q);
    var box = el('textarea', 'mxs__input mxs__textarea');
    box.id = 'mxs-words';
    box.rows = 3;
    box.maxLength = 500;
    f.appendChild(box);
    var btn = action('button', 'Send', true);
    btn.type = 'submit';
    btn.disabled = true;
    var row = el('div', 'mxs__actions');
    row.appendChild(btn);
    f.appendChild(row);
    box.addEventListener('input', function () { btn.disabled = !box.value.trim(); });
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var words = box.value.trim().slice(0, 500);
      if (!words) return;
      send('text', { reason: ctx.reason, text: words });
      track('text', { reason: ctx.reason, length: words.length });   // the length, never the words
      while (f.firstChild) f.removeChild(f.firstChild);
      var ok = el('p', 'mxs__done');
      ok.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      ok.appendChild(document.createTextNode('Thanks, we got it.'));
      f.appendChild(ok);
      liveMsg.textContent = 'Thanks, we got it.';
    });
    return f;
  }

  function shareButton() {
    var b = action('button', text.share, true);
    var url = location.origin + (ctx.url || location.pathname);
    var say = function (t) { b.textContent = t; liveMsg.textContent = t; };
    b.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({ title: document.title, url: url })
          .then(function () { track('shared', { method: 'share' }); })
          .catch(function () { /* the visitor cancelled */ });
        return;
      }
      var done = function () { track('shared', { method: 'copy' }); say(COPIED); };
      // No share sheet and no clipboard (some in-app browsers): show the link
      // itself, so it can be pressed and copied by hand.
      var show = function () { track('shared', { method: 'shown' }); say(url); b.classList.add('mxs__btn--url'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, show);
      else show();
    });
    return b;
  }

  function emailForm() {
    var f = el('form', 'mxs__email');
    f.noValidate = true;
    var q = el('label', 'mxs__q', fill(text.emailQ));
    q.htmlFor = 'mxs-email';
    f.appendChild(q);
    var row = el('div', 'mxs__field');
    var input = el('input', 'mxs__input');
    input.id = 'mxs-email';
    input.type = 'email';
    input.name = 'email';
    input.autocomplete = 'email';
    input.required = true;
    input.placeholder = 'Your email';
    row.appendChild(input);
    var btn = action('button', text.emailButton, true);
    btn.type = 'submit';
    btn.disabled = true;
    row.appendChild(btn);
    f.appendChild(row);
    var lab = el('label', 'mxs__consent');
    var box = el('input');
    box.type = 'checkbox';
    lab.appendChild(box);
    lab.appendChild(el('span', null, fill(text.emailConsent)));
    f.appendChild(lab);
    var msg = el('p', 'mxs__msg');
    msg.setAttribute('aria-live', 'polite');
    f.appendChild(msg);
    var valid = function () { return box.checked && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim()); };
    var refresh = function () { btn.disabled = !valid(); };
    input.addEventListener('input', refresh);
    box.addEventListener('change', refresh);
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!valid()) return;
      btn.disabled = true;
      msg.textContent = '';
      var address = input.value.trim();
      subscribe(address).then(function () {
        track('email', { reason: ctx.reason, days: ctx.days || null });
        klaviyoEvent(address);
        while (f.firstChild) f.removeChild(f.firstChild);
        var ok = el('p', 'mxs__done');
        ok.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
        ok.appendChild(document.createTextNode(text.emailDone));
        f.appendChild(ok);
        liveMsg.textContent = text.emailDone;
      }, function (err) {
        // The status code (never the address) shows what Klaviyo objected to.
        track('email_failed', { status: (err && err.status) || 0 });
        msg.textContent = "Sorry, that didn't go through. Please try again.";
        btn.disabled = false;
      });
    });
    return f;
  }

  // Klaviyo's client API: the public key (site ID) is meant for the browser.
  // Revisions are retired after a while — 2024-10-15 had been, and every
  // sign-up failed — so check this against Klaviyo's API reference when one
  // starts failing.
  var KLAVIYO_REVISION = '2026-07-15';
  function klaviyo(path, data) {
    return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(cfg.klaviyo.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: KLAVIYO_REVISION },
      body: JSON.stringify({ data: data })
    }).then(function (r) {
      if (r.ok) return;
      var e = new Error('Klaviyo ' + r.status);
      e.status = r.status;
      r.text().then(function (t) { if (window.console) console.warn('[Exit survey] Klaviyo ' + path, r.status, t); }, function () {});
      throw e;
    });
  }
  // Only the documented minimum: the list's own opt-in setting (single or
  // double) decides what happens next.
  function subscribe(email) {
    return klaviyo('subscriptions', {
      type: 'subscription',
      attributes: {
        custom_source: 'Pop-up workshop exit survey',
        profile: { data: { type: 'profile', attributes: {
          email: email,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      },
      relationships: { list: { data: { type: 'list', id: cfg.klaviyo.listId } } }
    });
  }
  // What they told us, as an event on their profile ("Pop-up survey sign-up"),
  // so segments can use city, reason and days. Best effort.
  function klaviyoEvent(email) {
    klaviyo('events', {
      type: 'event',
      attributes: {
        properties: { city: ctx.city || '', product: ctx.product || '', reason: ctx.reason || '', days: ctx.days || '', page: location.pathname },
        metric: { data: { type: 'metric', attributes: { name: 'Pop-up survey sign-up' } } },
        profile: { data: { type: 'profile', attributes: { email: email } } }
      }
    }).catch(function () { /* the subscription itself already went through */ });
  }

  function goTo(target) {
    var header = document.querySelector('.site-header, header');
    var hp = header ? getComputedStyle(header).position : '';
    var offset = (hp === 'fixed' || hp === 'sticky') ? header.offsetHeight + 16 : 16;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---------- the game: Mosaic match ----------------------------------- */

  // Glass colours: two jewel tones (Iznik, Ruby), the rest warm. Pearl (clear
  // glass) rather than Amber Deep, which was too close to Amber to tell apart.
  var GLASS = { amber: '#f08d27', iznik: '#1b6fa8', golden: '#f0b606', ruby: '#d63a32', ink: '#3d2210', pearl: '#f4ecda' };
  var GLASS_KEYS = ['amber', 'iznik', 'golden', 'ruby', 'ink', 'pearl'];
  // Reduced motion: the board is shown, but nothing moves and an answer goes
  // straight to the next step.
  var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function shuffle(a) {
    a = a.slice();
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  function retrigger(n, cls) { if (!n) return; n.classList.remove(cls); void n.offsetWidth; n.classList.add(cls); }
  // A timeout that does nothing once its node has left the page (the step
  // moved on, or the sheet closed).
  function later(n, ms, fn) { setTimeout(function () { if (n.isConnected) fn(); }, ms); }
  function buzz(p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) { /* not supported */ } }
  function drop(n, ms) { setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, ms); }

  // A 7 × 4 board of glass tiles. play(colour) throws the answer's tile to
  // where it joins the biggest group of that colour; the group bursts, the
  // colour pours back in and bursts once more, and the board refills. There
  // is no score and nothing to finish: one answer is the whole game.
  function mosaicBoard(stage, layer) {
    var COLS = 7, ROWS = 4, PAD = 7, GAP = 5, MAX = 40;
    var board = el('div', 'mxs__board'), aim = el('span', 'mxs__aim');
    board.setAttribute('aria-hidden', 'true');
    board.appendChild(aim);
    stage.appendChild(board);
    var grid = [], plans = {}, lit = [], playing = false, size, pitch, ox, r, c;

    function layout() {
      var w = stage.clientWidth;
      size = Math.max(16, Math.min(MAX, Math.floor((w - PAD * 2 - GAP * (COLS - 1)) / COLS)));
      pitch = size + GAP;
      ox = Math.round((w - (COLS * size + (COLS - 1) * GAP)) / 2);
      stage.style.height = (PAD * 2 + ROWS * size + (ROWS - 1) * GAP) + 'px';
      aim.style.width = aim.style.height = size + 'px';
    }
    function each(fn) { for (var r = 0; r < ROWS; r++) for (var c = 0; c < COLS; c++) if (grid[r][c]) fn(grid[r][c], r, c); }
    // Neighbours often share a colour, so there are groups worth bursting.
    function pick(r, c) {
      var o = [];
      if (c > 0 && grid[r][c - 1]) o.push(grid[r][c - 1].k);
      if (r + 1 < ROWS && grid[r + 1][c]) o.push(grid[r + 1][c].k);
      if (o.length && Math.random() < 0.42) return o[Math.floor(Math.random() * o.length)];
      return GLASS_KEYS[Math.floor(Math.random() * GLASS_KEYS.length)];
    }
    // Every colour must have a pair somewhere, so every answer bursts at least three.
    function hasPairs() {
      var seen = {};
      each(function (t, r, c) {
        if ((c + 1 < COLS && grid[r][c + 1].k === t.k) || (r + 1 < ROWS && grid[r + 1][c].k === t.k)) seen[t.k] = 1;
      });
      return GLASS_KEYS.every(function (k) { return seen[k]; });
    }
    var tries = 0;
    do {
      grid = [];
      for (r = 0; r < ROWS; r++) { grid.push([]); for (c = 0; c < COLS; c++) grid[r].push(null); }
      for (r = ROWS - 1; r >= 0; r--) for (c = 0; c < COLS; c++) grid[r][c] = { k: pick(r, c) };
    } while (!hasPairs() && ++tries < 400);

    function at(r, c, dy) { return 'translate(' + (ox + c * pitch) + 'px,' + (PAD + r * pitch + (dy || 0)) + 'px)'; }
    function skin(t) { t.el.firstChild.style.setProperty('--mxs-c', GLASS[t.k]); }
    function make(t) {
      t.el = el('span', 'mxs__tile');
      t.el.style.width = t.el.style.height = size + 'px';
      t.el.appendChild(el('span', 'mxs__glass'));
      skin(t);
      board.appendChild(t.el);
      return t;
    }
    function put(t, r, c, delay) { t.el.style.transitionDelay = (delay || 0) + 'ms'; t.el.style.transform = at(r, c); }
    // Tiles start above their place and fall in: [tile, row, col, start offset, delay].
    function fallIn(list) {
      list.forEach(function (d) { d[0].el.style.transition = 'none'; d[0].el.style.transform = at(d[1], d[2], d[3]); });
      void board.offsetWidth;
      list.forEach(function (d) { d[0].el.style.transition = ''; put(d[0], d[1], d[2], still ? 0 : d[4]); });
    }

    layout();
    var first = [];
    each(function (t, r, c) { first.push([make(t), r, c, -(ROWS * pitch + 20), 200 + c * 50 + (ROWS - 1 - r) * 45]); });
    fallIn(first);
    if (!still) board.classList.add('is-shine');
    // The stylesheet may arrive after the board is built, and phones turn:
    // keep the tiles on the board's real width.
    var lastW = stage.clientWidth;
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        var w = stage.clientWidth;
        if (!w || w === lastW || playing) return;
        lastW = w;
        layout();
        each(function (t, r, c) {
          t.el.style.width = t.el.style.height = size + 'px';
          t.el.style.transition = 'none';
          t.el.style.transform = at(r, c);
        });
        void board.offsetWidth;
        each(function (t) { t.el.style.transition = ''; });
      }).observe(stage);
    }

    function group(r0, c0, k) {
      var out = [], seen = {}, q = [[r0, c0]];
      while (q.length) {
        var p = q.pop(), r = p[0], c = p[1], id = r * COLS + c;
        if (seen[id] || r < 0 || c < 0 || r >= ROWS || c >= COLS) continue;
        seen[id] = 1;
        if (!(r === r0 && c === c0) && (!grid[r][c] || grid[r][c].k !== k)) continue;
        out.push([r, c]);
        q.push([r + 1, c], [r - 1, c], [r, c + 1], [r, c - 1]);
      }
      return out;
    }
    function biggest(k) {
      var best = [], seen = {};
      each(function (t, r, c) {
        if (t.k !== k || seen[r * COLS + c]) return;
        var g = group(r, c, k);
        g.forEach(function (q) { seen[q[0] * COLS + q[1]] = 1; });
        if (g.length > best.length) best = g;
      });
      return best;
    }
    // Where a colour's tile will land: worked out once, so the preview and the play agree.
    function plan(k) {
      if (plans[k]) return plans[k];
      var best = null;
      each(function (t, r, c) {
        if (t.k === k) return;
        var g = group(r, c, k);
        if (!best || g.length > best.g.length || (g.length === best.g.length && Math.random() < 0.3)) best = { r: r, c: c, g: g };
      });
      return (plans[k] = best);
    }
    function clear() {
      lit.forEach(function (t) { t.el.classList.remove('is-lit', 'is-under'); });
      lit = [];
      aim.classList.remove('is-on');
    }
    // The tiles it would burst light up; a ghost tile shows where it lands.
    function preview(k) {
      clear();
      var p = plan(k);
      p.g.forEach(function (q) {
        var t = grid[q[0]][q[1]];
        t.el.classList.add(q[0] === p.r && q[1] === p.c ? 'is-under' : 'is-lit');
        lit.push(t);
      });
      aim.style.setProperty('--mxs-at', at(p.r, p.c));
      aim.style.transform = at(p.r, p.c);
      aim.style.setProperty('--mxs-c', GLASS[k]);
      aim.classList.add('is-on');
    }
    function glint(k) {
      var n = 0;
      each(function (t) {
        if (t.k !== k) return;
        (function (t, d) { later(t.el, d, function () { retrigger(t.el, 'is-glint'); }); })(t, n++ * 55);
      });
    }
    function wobble(frames, ms) { if (!still && board.animate) board.animate(frames, { duration: ms, easing: 'ease-out' }); }
    function nudge() { wobble([{ transform: 'none' }, { transform: 'translateX(-5px) rotate(-0.6deg)' }, { transform: 'translateX(4px) rotate(0.5deg)' }, { transform: 'translateX(-2px)' }, { transform: 'none' }], 360); }
    function shake() { wobble([{ transform: 'none' }, { transform: 'translate(-2px, 2px)' }, { transform: 'translate(2px, -1px)' }, { transform: 'none' }], 200); }

    // Positions on the effects layer, which covers the sheet.
    function centre(n) {
      var lr = layer.getBoundingClientRect(), b = n.getBoundingClientRect();
      return { x: b.left - lr.left + b.width / 2, y: b.top - lr.top + b.height / 2, w: b.width, h: b.height };
    }
    function shards(n, k) {
      var p = centre(n);
      for (var i = 0; i < 5; i++) {
        var b = el('span', 'mxs__bit'), a = Math.random() * Math.PI * 2, d = 24 + Math.random() * 44;
        b.style.left = (p.x - 4) + 'px';
        b.style.top = (p.y - 4) + 'px';
        b.style.backgroundColor = GLASS[k];
        b.style.setProperty('--mxs-dx', Math.cos(a) * d + 'px');
        b.style.setProperty('--mxs-dy', Math.sin(a) * d + 30 + 'px');
        b.style.setProperty('--mxs-rot', (Math.random() * 360 - 180) + 'deg');
        layer.appendChild(b);
        drop(b, 1000);
      }
    }
    function burst(g, k) {
      g.forEach(function (q) {
        var t = grid[q[0]][q[1]];
        if (!t) return;
        shards(t.el, k);
        t.el.classList.add('is-gone');
        drop(t.el, 200);
        grid[q[0]][q[1]] = null;
      });
      plans = {};
    }
    // Close the gaps; new tiles fall in from the top. `pour` fills them with one colour.
    function refill(pour) {
      var moves = [];
      for (var c = 0; c < COLS; c++) {
        var w = ROWS - 1;
        for (var r = ROWS - 1; r >= 0; r--) {
          if (!grid[r][c]) continue;
          if (r !== w) { grid[w][c] = grid[r][c]; grid[r][c] = null; put(grid[w][c], w, c, c * 18); }
          w--;
        }
        for (r = w; r >= 0; r--) {
          grid[r][c] = make({ k: pour || pick(r, c) });
          moves.push([grid[r][c], r, c, -(w + 1) * pitch - 12, c * 18 + 60]);
        }
      }
      fallIn(moves);
      plans = {};
    }
    function say(str, g) {
      var x = 0, y = 0;
      g.forEach(function (q) { var p = centre(grid[q[0]][q[1]].el); x += p.x; y += p.y; });
      var n = el('span', 'mxs__pop', str);
      n.style.left = (x / g.length) + 'px';
      n.style.top = (y / g.length) + 'px';
      layer.appendChild(n);
      drop(n, 1000);
    }
    function wave(r0, c0) {
      each(function (t, r, c) {
        later(t.el, Math.hypot(r - r0, c - c0) * 55, function () { retrigger(t.el, 'is-wave'); });
      });
    }
    // The answer's tile flies from its button to the board, with a short trail.
    function fly(from, to, k, cb) {
      if (!from.animate) { cb(); return; }
      var a = centre(from), b = centre(to), s0 = a.w / b.w, dx = a.x - b.x, dy = a.y - b.y;
      var frames = [
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s0 + ') rotate(0deg)' },
        { transform: 'translate(' + dx * 0.4 + 'px,' + (dy * 0.4 - 60) + 'px) scale(' + (s0 + 1.5) / 2 + ') rotate(190deg)', offset: 0.55 },
        { transform: 'translate(0px, 0px) scale(1) rotate(360deg)' }
      ];
      for (var i = 3; i >= 0; i--) {
        var f = el('span', i ? 'mxs__flyer is-ghost' : 'mxs__flyer');
        f.style.setProperty('--mxs-c', GLASS[k]);
        f.style.width = b.w + 'px';
        f.style.height = b.h + 'px';
        f.style.left = (b.x - b.w / 2) + 'px';
        f.style.top = (b.y - b.h / 2) + 'px';
        if (i) f.style.opacity = String(0.44 - i * 0.12);
        layer.appendChild(f);
        var an = f.animate(frames, { duration: 480, delay: i * 32, easing: 'cubic-bezier(0.35, 0.6, 0.4, 1)', fill: 'backwards' });
        (function (f, lead) {
          an.onfinish = function () { if (f.parentNode) f.parentNode.removeChild(f); if (lead) cb(); };
        })(f, i === 0);
      }
    }
    function play(k, from, done) {
      clear();
      playing = true;
      each(function (t) { t.el.style.transitionDelay = '0ms'; });
      var p = plan(k), t = grid[p.r][p.c];
      var finish = function () { wave(p.r, p.c); later(board, 380, done); };
      fly(from, t.el, k, function () {
        t.k = k;
        skin(t);
        retrigger(t.el, 'is-landed');
        buzz(8);
        var g = group(p.r, p.c, k);
        later(board, 120, function () {
          g.forEach(function (q) { grid[q[0]][q[1]].el.classList.add('is-flash'); });
          later(board, 200, function () {
            burst(g, k);
            shake();
            buzz(14);
            later(board, 130, function () {
              refill(k);   // the colour pours back in, which sets up the combo
              later(board, 640, function () {
                var g2 = biggest(k);
                if (g2.length < 3) { finish(); return; }
                g2.forEach(function (q) { grid[q[0]][q[1]].el.classList.add('is-flash'); });
                later(board, 200, function () {
                  say('Combo!', g2);
                  burst(g2, k);
                  shake();
                  buzz([10, 40, 14]);
                  later(board, 130, function () { refill(null); later(board, 480, finish); });
                });
              });
            });
          });
        });
      });
    }
    return { preview: preview, clear: clear, glint: glint, nudge: nudge, play: play };
  }

  /* ---------- the FAQ link -------------------------------------------- */

  // An <a href="…#tell-us-what-works"> anywhere on the page opens the sheet
  // at "Which days usually suit you?". Without the survey (off, or no
  // JavaScript) the link simply goes where its href points.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="#tell-us-what-works"]') : null;
    if (!a || !active) return;
    e.preventDefault();
    if (!sheet) open({ trigger: 'faq_link', start: 'days', focus: true });
  });

  /* ---------- workshop page: watch for leaving ------------------------- */

  // A booking made earlier in this visit (this tab), on any workshop page.
  // dataLayer starts empty on every page load, so it is carried over here.
  var lastVisit = isWorkshop ? readJSON('sessionStorage', VISIT) : null;
  var bookedBefore = !!(lastVisit && lastVisit.booked);
  var bookingPending = false;   // a booking still waiting in the cart (checked below)

  function saveVisit() {
    var s = pageState();
    write('sessionStorage', VISIT, JSON.stringify({
      handle: cfg.page.handle, city: cfg.page.city, url: cfg.page.url, at: Date.now(),
      sawDates: s.sawDates, started: s.started, booked: s.booked || bookedBefore, bucket: s.bucket
    }));
  }

  /* ---------- a booking left unfinished at checkout ------------------- */

  // The booking widget puts the booking in the cart and goes straight to
  // Shopify's checkout, which is not part of the theme. Someone who comes
  // back to the site without paying still has it in the cart (a finished
  // order empties the cart), so that is what is checked.
  function pendingBooking(cb) {
    if (preview && forceCheckout) { cb(true); return; }
    if (!window.fetch) { cb(false); return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        cb(!!(c && (c.items || []).some(function (li) { return li.properties && li.properties._date_iso8601; })));
      }, function () { cb(false); });
  }
  function checkoutCapped() {
    if (preview) return false;
    if (read('sessionStorage', SHOWN_CHECKOUT)) return true;
    var c = readJSON('localStorage', CAP) || {};
    return !!(c.checkoutUntil && Date.now() < c.checkoutUntil);
  }
  // Asked once per visit, and not again for a week; a few seconds after the
  // page settles, when nothing else is in the way.
  function askCheckout(trigger) {
    if (!active || checkoutCapped()) return;
    pendingBooking(function (yes) {
      if (!yes) return;
      bookingPending = true;
      setTimeout(function tryAsk() {
        if (sheet || klaviyoShown || offerHere() || checkoutCapped()) return;
        if (busy() || document.hidden) { setTimeout(tryAsk, 2000); return; }
        askedHere = true;
        open({ trigger: trigger, question: 'checkout' });
      }, preview ? 500 : 3000);
    });
  }

  function ask(trigger) {
    if (!mayAsk()) return;
    var s = pageState();
    ctx.sawDates = s.sawDates;
    ctx.started = s.started;
    ctx.bucket = s.bucket;
    askedHere = true;
    open({ trigger: trigger });
  }

  function watchWorkshop() {
    ctx.city = cfg.page.city;
    ctx.product = cfg.page.handle;
    ctx.url = cfg.page.url;
    saveVisit();
    window.addEventListener('pagehide', saveVisit);
    document.addEventListener('visibilitychange', function () { if (document.hidden) saveVisit(); });
    // Someone who taps a date while the sheet is up gets the booking dialog,
    // and the sheet steps aside.
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (sheet && document.documentElement.classList.contains('masbk-lock')) close('booking');
      }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }

    // In Test, ordinary visitors only get the visit recorded (so a preview
    // can pick it up later); none of the listeners below.
    if (!active) return;
    if (openNow) {
      askedHere = true;
      setTimeout(function () { open({ trigger: 'test_link', question: forceCheckout ? 'checkout' : 'booking' }); }, 900);
      return;
    }
    // Back from checkout without paying: ask about that, not the usual question.
    if (bookedBefore || forceCheckout) askCheckout('back_from_checkout');
    // The same, when the browser restores this page as it was (the back button).
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && pageState().booked && !sheet) askCheckout('back_from_checkout');
    });
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var minExit = preview ? 0 : (T.exitMin || 0);
    var minHes = preview ? 0 : (T.hesitationMin || 20);
    var minFor = fine ? minExit : minHes;

    if (fine) {
      // Leaving through the top edge: towards the tabs, the address bar, the back button.
      document.addEventListener('mouseout', function (e) {
        if (e.relatedTarget || e.clientY > 5) return;
        if (past(minExit)) ask('exit');
      });
    } else {
      if (T.endOfPage) {
        var ticking = false;
        window.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var doc = document.documentElement;
            var atEnd = window.pageYOffset + window.innerHeight >= doc.scrollHeight - window.innerHeight * 0.5;
            if (atEnd && past(minHes)) ask('end_of_page');
          });
        }, { passive: true });
      }
      if (T.idle > 0) {
        var last = Date.now();
        var poke = function () { last = Date.now(); };
        ['scroll', 'touchstart', 'pointerdown', 'keydown'].forEach(function (t) {
          window.addEventListener(t, poke, { passive: true });
        });
        var idleTimer = setInterval(function () {
          if (askedHere || capped()) { clearInterval(idleTimer); return; }
          if (!document.hidden && Date.now() - last >= T.idle * 1000 && past(minHes)) ask('idle');
        }, 1000);
      }
    }
    if (T.onReturn) {
      var hiddenAt = 0;
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { hiddenAt = Date.now(); return; }
        if (hiddenAt && Date.now() - hiddenAt >= AWAY_MS) {
          hiddenAt = 0;
          setTimeout(function () { if (past(minFor)) ask('return'); }, 600);
        }
      });
    }
    if (cfg.editor) setTimeout(function () { open({ trigger: 'editor' }); }, 600);
  }

  /* ---------- any other page: ask about the workshop they just left ---- */

  function askNextPage() {
    var v = readJSON('sessionStorage', VISIT);
    var maxAge = (T.nextPageMinutes || 30) * 60000;
    if (!active || !T.nextPage || !v || Date.now() - v.at > maxAge) return;
    ctx.city = v.city;
    ctx.product = v.handle;
    ctx.url = v.url;
    ctx.sawDates = v.sawDates;
    ctx.started = v.started;
    ctx.bucket = v.bucket;
    // They booked: ask only if the booking was left unfinished in the cart.
    if (v.booked) { askCheckout('next_page'); return; }
    var wait = preview ? 500 : (T.nextPageDelay || 3) * 1000;
    setTimeout(function tryAsk() {
      if (sheet || askedHere || klaviyoShown || offerHere() || capped()) return;
      if (busy() || document.hidden) { setTimeout(tryAsk, 2000); return; }
      askedHere = true;
      open({ trigger: 'next_page' });
    }, wait);
  }

  window.MASExitSurvey = { open: function (o) { if (active) open(o || { trigger: 'manual' }); } };
  if (isWorkshop) watchWorkshop();
  else askNextPage();
  if (active) ensureCss();
})();
